import React, {useState} from 'react';
import {Link, useLocation} from 'react-router-dom';
import styled from 'styled-components';
import logoImg from '../../assets/derobo.png';
import WalletButtonBase from './views/WalletButton';
import Spacer from "../Spacer";
import mobileMenuImg from "../../assets/buttons/btn_menu.svg";
import logoMobileImg from "../../assets/logo_mobile.svg";
import WalletButtonMobileMenu from "./views/WalletButtonMobileMenu";
import closeMobileImg from "../../assets/buttons/close_mobile_white_24.svg";


const HeaderWrapper = styled.div`
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  border-radius: 0 0 40px 40px;
  position: fixed;
  width: 100%;
  z-index: 99;  
  top: 0;
  @media (max-width: 768px) {
    border-radius: 0;
    height: 90px;
    align-items: end;
  }
`;
const Block = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 1110px;

  @media (max-width: 768px) {
    display: flex;
    align-items: center;
    padding: 10px 8px;
    flex-wrap: wrap;
    flex-direction: row;
    height: auto;
  }
`;

const Logo = styled.div`
  margin-left: 20px;
  display: block;

  @media (max-width: 767.9px) {
    margin-top: 20px;
    margin-bottom: 20px;
    margin-left: 0;
    display: none;
  }
`;

const MobileMenu = styled.div`
  margin-left: 20px;
  display: none;
  cursor: pointer;

  img {
    width: 44px;
    height: 44px;
  }

  @media (max-width: 768px) {
    display: block;
  }
`;

const FlexEnd = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 20px;
  @media (max-width: 767.9px) {
    margin-right: 0;
  }
`;
const LinksWrapper = styled(FlexEnd)`

  @media (max-width: 767.9px) {
    display: none;
  }
`;

interface StyledHeaderLinkProps {
    isClicked: boolean;
}

const StyledHeaderLink = styled(Link)<StyledHeaderLinkProps>`
  font-size: 14px;
  transition: 0.2s;
  font-weight: ${props => props.isClicked ? 700 : 400};
  color: ${props => props.isClicked ? "#6482E6" : "#252525"};
  box-shadow: ${props => props.isClicked ? "inset 0px 2px 2px rgba(0, 0, 0, 0.18)" : "none"};
  background: ${props => props.isClicked ? "#E3E9FF" : "#fff"};
  border-radius: 10px;
  height: 36px;
  width: 126px;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;

  &:hover {
    background: #E3E9FF;
    box-shadow: inset 0px 2px 2px rgba(0, 0, 0, 0.18);
    color: #6482E6;
    font-weight: 700;
  }
`;

const MobileMenuWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: #fff;
  z-index: 15000;
`;

const MobileMenuHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: calc(100vh - 47px);
  background: rgba(115, 144, 254, 0.95);
  backdrop-filter: blur(3px);
  width: 100%;
  border-radius: 0 0 40px 40px;
`;

const CloseIcon = styled.div`
  padding: 3px;
  margin-top: 65px;
  cursor: pointer;

  img {
    width: 24px;
    height: 24px;
  }
`;

const LineSpacer = styled.div`
  height: 1px;
  width: 217px;
  background: #fff;
  margin-top: 50px;
  margin-bottom: 50px;
`;

interface StyledHeaderLinkProps {
    isClicked: boolean;
}

const StyledHeaderMobileLink = styled(Link)<StyledHeaderLinkProps>`
  font-size: 14px;
  transition: 0.2s;
  font-weight: ${props => props.isClicked ? 400 : 400};
  color: ${props => props.isClicked ? "#6482E6" : "#252525"};
  box-shadow: ${props => props.isClicked ? "inset 0px 2px 2px rgba(0, 0, 0, 0.18)" : "none"};
  background: ${props => props.isClicked ? "#BCCAFF" : "#fff"};
  border-radius: 10px;
  height: 60px;
  width: 354px;
  max-width: calc(100% - 30px);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;

  &:hover {
    background: #E3E9FF;
    box-shadow: inset 0px 2px 2px rgba(0, 0, 0, 0.18);
    color: #6482E6;
  }
`;

const Header = () => {

    const location = useLocation();
    const currentPage = location.pathname;
    const [openedMobile, setOpenedMobile] = useState(false);
    const closeModal = () => {
        setOpenedMobile(false);
    };

    return (
        <HeaderWrapper>
            <Block>
                <Logo>
                    <Link to="/">
                        <img src={logoImg} alt="mainPage" style={{height: 31}}/>
                    </Link>
                </Logo>

                <MobileMenu onClick={() => setOpenedMobile(true)}>
                    <img src={mobileMenuImg} alt="mobile menu"/>
                </MobileMenu>

                <LinksWrapper>
                    <StyledHeaderLink to="/analytics" isClicked={currentPage === "/analytics"}>Analytics</StyledHeaderLink>
                    <Spacer/>
                    <StyledHeaderLink to="/robofarm" isClicked={currentPage === "/robofarm"}>Robots</StyledHeaderLink>
                    <Spacer/>
                    <StyledHeaderLink to="/portfolio" isClicked={currentPage === "/portfolio"}>My portfolio</StyledHeaderLink>
                    <Spacer/>
                </LinksWrapper>

                <FlexEnd>
                    <WalletButtonBase/>
                </FlexEnd>
            </Block>

            {openedMobile && <MobileMenuWrapper>
                <MobileMenuHeader>
                    <img src={logoMobileImg} alt="" style={{width: 157, marginBottom: 65}}/>
                    <StyledHeaderMobileLink to="/analytics" isClicked={currentPage === "/analytics"} onClick={closeModal}>Analytics</StyledHeaderMobileLink>
                    <StyledHeaderMobileLink to="/robofarm" isClicked={currentPage === "/robofarm"} onClick={closeModal}>Robots</StyledHeaderMobileLink>
                    <StyledHeaderMobileLink to="/portfolio" isClicked={currentPage === "/portfolio"} onClick={closeModal}>My portfolio</StyledHeaderMobileLink>
                    <LineSpacer/>
                    <WalletButtonMobileMenu/>
                    <CloseIcon onClick={closeModal}>
                        <img src={closeMobileImg} alt="Close Icon"/>
                    </CloseIcon>
                </MobileMenuHeader>
            </MobileMenuWrapper>}
        </HeaderWrapper>
    );
};

export default Header;
